import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import Tab from "../../components/Tab/Tab";
import Tabs from "../../components/Tabs/Tabs";
import TabPanel from "../../components/TabPanel/TabPanel";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import Timesheet from "./Timesheet";
import TimesheetManagerReview from "../timesheet-manager-review/TimesheetManagerReview";
import { useRbac } from "../../hooks/RbacContext";
import { Navigate } from "react-router-dom";

const a11yProps = (index) => {
  return {
    id: `timesheet-tab-${index}`,
    "aria-controls": `timesheet-tabpanel-${index}`,
  };
};

const TimesheetDetails = () => {
  const [value, setValue] = useState(0);
  const { permissions, hasActionPermission } = useRbac();

  const canAccessTimesheet = hasActionPermission("Timesheet", "view");

  const isProjectManager = permissions?.projectRoles?.some(
    (projectRole) =>
      parseInt(projectRole.role?.role_id) ===
      parseInt(process.env.REACT_APP_PM_ROLE_ID)
  );

  const superAdminRoleIds = process.env.REACT_APP_SUPER_ADMIN_ROLE_ID
    ? process.env.REACT_APP_SUPER_ADMIN_ROLE_ID.split(",").map((id) =>
        parseInt(id.trim())
      )
    : [];

  const isSuperAdmin = superAdminRoleIds.includes(
    parseInt(permissions?.globalRole?.role_id)
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (!canAccessTimesheet) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <div sx={{ width: "100%", px: "0px", py: "0px" }}>
      <Box
        sx={{
          borderBottom: 2,
          borderColor: "divider",
        }}
      >
        <Tabs value={value} onChange={handleChange} aria-label="timesheet tabs">
          <Tab
            icon={<AccessTimeIcon />}
            iconPosition="start"
            label="My Timesheet"
            {...a11yProps(0)}
          />
          {(isProjectManager || isSuperAdmin) && (
            <Tab
              icon={<ManageAccountsIcon />}
              iconPosition="start"
              label="Review Timesheet"
              {...a11yProps(1)}
            />
          )}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Timesheet />
      </TabPanel>

      {(isProjectManager || isSuperAdmin) && (
        <TabPanel value={value} index={1}>
          <TimesheetManagerReview />
        </TabPanel>
      )}
    </div>
  );
};

export default TimesheetDetails;
